import { defaultFilter } from '@components/Table/table.utils';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/')({
  validateSearch: zodValidator(withDefaults(schema.DATA_UNIFICATION_ENTITIES, defaultFilter)),
});
